// extracted by mini-css-extract-plugin
export default {"icon":"StatusIcon_icon__ggHuF"};